export const pageStoreTypes = {
  actions: {
    getPage: "GET_PAGE",
  },
};
